import md5 from 'crypto-js/md5';

export const hashEmail = (email: string): string => md5(email?.toLowerCase().trim()).toString();
